var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInvestment = function SvgInvestment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    x: 3,
    y: 3,
    fill: "#E2FFEA",
    rx: 27
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    x: 3,
    y: 3,
    stroke: "#F4FFF7",
    strokeWidth: 6,
    rx: 27
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    d: "M29.334 17a6 6 0 0 1 5.781 4.39l.07.273 2.493-.623a1.332 1.332 0 0 1 1.644 1.12l.012.173v2.414a8.7 8.7 0 0 1 1.818 2.509l.184.41H42a1.333 1.333 0 0 1 1.324 1.178l.01.156v4a1.33 1.33 0 0 1-.594 1.11l-.144.082-1.557.78a8.7 8.7 0 0 1-2.693 3.1l-.346.232v1.363a1.333 1.333 0 0 1-1.177 1.324l-.156.009h-4a1.333 1.333 0 0 1-1.324-1.177l-.01-.156H30a1.333 1.333 0 0 1-1.177 1.324l-.156.009h-4a1.333 1.333 0 0 1-1.324-1.177l-.01-.156v-1.363a8.68 8.68 0 0 1-3.805-5.468 4 4 0 0 1-2.853-3.59L16.667 29v-.667a1.333 1.333 0 0 1 2.657-.156l.01.156V29c0 .197.042.385.12.553a8.67 8.67 0 0 1 3.917-5.881A6 6 0 0 1 29.334 17m7.333 7.04-3.677.92-.16.03-.163.01H28a6 6 0 0 0-2.726 11.347 1.33 1.33 0 0 1 .716 1.021l.01.165v.8h1.334a1.333 1.333 0 0 1 1.177-1.324l.156-.009h4a1.333 1.333 0 0 1 1.324 1.177l.01.156h1.333v-.8a1.33 1.33 0 0 1 .726-1.186 6.03 6.03 0 0 0 2.758-2.907c.1-.224.26-.417.462-.556l.159-.093 1.228-.615v-1.843h-.276a1.33 1.33 0 0 1-1.283-.97 6 6 0 0 0-1.957-2.992 1.33 1.33 0 0 1-.473-.859l-.011-.17zm-1.333 3.627a1.333 1.333 0 1 1 0 2.666 1.333 1.333 0 0 1 0-2.666m-6-8a3.33 3.33 0 0 0-3.304 2.892 8.7 8.7 0 0 1 1.97-.226h4.503l.093-.022a3.33 3.33 0 0 0-3.262-2.644"
  })));
};
export default SvgInvestment;